import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import PixelEdumanLoader from '../loading/PixelEdumanLoader';
import region6 from '../../assets/images/icons/regions/region6.png';
import redirectIcon from '../../assets/images/icons/utility/redirect-icon.svg';
import RedirectIcon from "../icons/utility/RedirectIcon";
import ProtectedRouteSwitch from "../accessControl/ProtectedRoutesSwitch";



const Search = ({focusOnSearch, setControlPanel, controlPanel}) => {
    // ===================== HOOKS =====================
    const [tabSelected, setTabSelected] = useState({name: "Home"});
    // const [controlPanelButton, setControlPanelButton] = useState(false);
    const [categorySearchResults, setCategorySearchResults] = useState(false);
    const [controlPanelCategory, setControlPanelCategory] = useState(false);
    const [searching, setSearching] = useState(false);
    const [searchValid, setSearchValid] = useState(false);
    const [indexedStaticCategories, setIndexedStaticCategories] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [refinedFilter, setRefinedFilter] = useState(false);

    // houses the returned function for debouncing search input
    const debounceContainer = useRef(false);

    // ===================== CP DATA ===================== 
    const staticPages = [
        {
            name: "Learning",
            to: "./learning",
        },
        {
            name: "Custom Portal",
            to: "./customPortal"
        },
        {
            name: "Store",
            to: "./store"
        },
    ];

    // static data categories
    const staticCpCategories = [
        {
            name: "Pages",
            hasIcons: true,
            clickToLearn: false,
            links: [
                {
                    name: "Certificates",
                    link: "./certificates",
                    description: "Manage certificates.",
                    icon: require("../../assets/images/icons/eduhero/certificates.png"),
                    relatedLinks: [
                        
                    ]
                },
                {
                    name: "Campus",
                    link: "./campus",
                    description: "Create and manage campuses.",
                    icon: require("../../assets/images/icons/eduhero/campus.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Courses",
                    link: "./courses",
                    description: "Create custom courses for staff.",
                    icon: require("../../assets/images/icons/eduhero/content.png"),
                    relatedLinks: [
                        {
                            name: "Create Courses",
                            link: "./courses/addCourses"
                        },
                        {
                            name: "Create Family",
                            link: "./courses/addCourseFamily"
                        },
                        {
                            name: "Create Series",
                            link: "./courses/addCourseSeries"
                        },
                    ]
                },
                {
                    name: "Evaluations",
                    link: "./evaluations",
                    description: "Manage surveys.",
                    icon: require("../../assets/images/icons/eduhero/evaluations.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Grade Levels",
                    link: "./gradeLevels",
                    description: "Add and manage grade levels.",
                    icon: require("../../assets/images/icons/eduhero/content.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Groups",
                    link: "./groups",
                    description: "Add and manage groups.",
                    icon: require("../../assets/images/icons/eduhero/groups.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "News",
                    link: "./news",
                    description: "Compose and manage news for staff.",
                    icon: require("../../assets/images/icons/eduhero/newsletters.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Packages",
                    link: "./packages",
                    description: "Create and manage course packages.",
                    icon: require("../../assets/images/icons/eduhero/packages.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Plans",
                    link: "./plans",
                    description: "Create tailored course plans for staff.",
                    icon: require("../../assets/images/icons/eduhero/plans.png"),
                    relatedLinks: [
                        {
                            name: "Create Plan",
                            link: "./plans/createPlan"
                        }
                    ]
                },
                {
                    name: "Permissions",
                    link: "./permissions",
                    description: "Add and manage custom permissions for staff.",
                    icon: region6,
                    relatedLinks: [

                    ]
                },
                {
                    name: "Reports",
                    link: "./reports",
                    description: "Access detailed reports.",
                    icon: require("../../assets/images/icons/eduhero/reports.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Roles",
                    link: "./roles",
                    description: "Add and manage custom roles for staff.",
                    icon: region6,
                    relatedLinks: [

                    ]
                },
                {
                    name: "Social",
                    link: "./social",
                    description: "Edit home page sliders.",
                    icon: require("../../assets/images/icons/eduhero/featured.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Share Subscriptions",
                    link: "./subscriptions",
                    description: "Share access with district and non-district emails.",
                    icon: require("../../assets/images/icons/eduhero/subs.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Students",
                    link: "./students",
                    description: "Create and manage student accounts for limited access.",
                    icon: require("../../assets/images/icons/eduhero/students.png"),
                    relatedLinks: [
                        {
                            name: "Upload Students",
                            link: "./students/bulkUpload/Add"
                        }
                    ]
                },
                {
                    name: "Transactions",
                    link: "./transactions",
                    description: "View all completed purchases.",
                    icon: require("../../assets/images/icons/eduhero/transactions.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "User Appearance",
                    link: "./appearance",
                    description: "Add and manage custom avatars and backgrounds for staff.",
                    icon: require("../../assets/images/icons/eduhero/avatars.png"),
                    relatedLinks: [

                    ]
                },
                {
                    name: "Users",
                    link: "./users",
                    description: "Create and manage district accounts.",
                    icon: require("../../assets/images/icons/eduhero/users.png"),
                    relatedLinks: [
                        {
                            name: "Upload Users",
                            link: "./users/uploadUsers/Add"
                        },
                        {
                            name: "Merge Account",
                            link: "./users/mergeAccount"
                        },
                        {
                            name: "Create User",
                            link: "./users/createUser"
                        },
                        {
                            name: "Sync Systems",
                            link: "./users/syncSystems"
                        },
                        {
                            name: "Schedule User Dump",
                            link: "./users/scheduleUserDump"
                        },
                    ]
                }
            ]
        },
        {
            name: "Help",
            hasIcons: false,
            clickToLearn: true,
            links: [
                {
                    name: "Clear cache",
                    link: "./help/clearCache",
                    description: "Experiencing strange errors? Try clearing your cache.",
                    relatedLinks: [

                    ]
                },
                {
                    name: "Where's my certificate",
                    link: "./help/obtainCertificate",
                    description: "Can't find your certificate? Try the following steps on our guide.",
                    relatedLinks: [

                    ]
                },
            ]
        },
    ];

    // categories with fluctuating data
    const dynamicCpCategories = [
        {
            name: "Notifications",
            hasIcons: false,
            clickToLearn: true,
            links: [
                {
                    name: "Plan Expiry",
                    link: "./notifications/123av3",
                    description: "The plan you are assigned to has expired."
                },
                {
                    name: "New course",
                    link: "./notifications/sdgfa",
                    description: "A new course has been added to the family: bloodborne pathogens."
                },
            ]
        },
        
        {
            name: "Catalog",
            hasIcons: false,
            clickToLearn: true,
            links: [
                {
                    name: "Bloodborne Pathogens",
                    link: "./courses/12345",
                    description: "In this course you will learn about hemohazards."
                },
                {
                    name: "How to make a sandwich",
                    link: "./courses/334983489",
                    description: "Wanna make a sandwich?"
                },
                {
                    name: "How to make a better sandwich",
                    link: "./courses/334983489",
                    description: "Wanna make a really good sandwich?"
                },
            ]
        },
        {
            name: "News",
            hasIcons: false,
            clickToLearn: true,
            links: [
                {
                    name: "Clear cache",
                    link: "./news/clearCache",
                    description: "We updated courses. Try clearing your cache."
                },
                {
                    name: "Lost certificates",
                    link: "./help/obtainCertificate",
                    description: "We found all the lost certs yall keep calling about."
                },
            ]
        },
    ];

    // ===================== FUNCTIONS =====================
    // on input change, update the state
    const searchOnChangeHandler = (e) => {
        setSearchValue(e.target.value);
    };

    // on x icon press, clear the input
    const clearSearchBarHandler = (e) => {
        setSearchValue("");
        focusOnSearch();
    };

    // flattens and maps out (indexes) all the links and related links
    const partialIndex = (list) => {
        let index = [];

        list.forEach((category, categoryIndex) => {
            category.links.forEach((link, linkIndex) => {
                index.push(
                    {
                        categoryIndex,
                        linkIndex,
                        field: "name",
                        value: link.name.toLowerCase()
                    }
                );

                index.push(
                    {
                        categoryIndex,
                        linkIndex,
                        field: "description",
                        value: link.description.toLowerCase()
                    }
                );

                if(link.hasOwnProperty("relatedLinks")) {
                    link.relatedLinks.forEach((relatedLink, relatedLinkIndex) => {
                        index.push(
                            {
                                categoryIndex,
                                linkIndex,
                                relatedLinkIndex,
                                field: "relatedLinksName",
                                value: relatedLink.name.toLowerCase()
                            }
                        )
                    });
                }
            });
        });

        return index;
    };

    // searches through indexes list and returns an array
    const indexSearch = (needle) => {
        const lowerNeedle = needle.toLowerCase();

        return indexedStaticCategories.filter((entry) => entry.value.includes(lowerNeedle));
    };

    // rebuilds the original object structure from the indexSearch results
    const rebuildIndexSearch = (indexList, filterRelatedLinks = false) => {
        let result = [];

        // loops through all matches to search query
        indexList.forEach(({categoryIndex, linkIndex, relatedLinkIndex}, i) => {
            let resultCategoryIndex = false;
            // if the result obj doesnt have a matched category, put it in there
            if(!result.some(r => r.name === staticCpCategories[categoryIndex].name)) {                
                result.push({...staticCpCategories[categoryIndex], links: []});
            }

            // finds new index of category index inside of result
            result.forEach((rc, rcIndex) => {
                if(rc.name === staticCpCategories[categoryIndex].name) {
                    resultCategoryIndex = rcIndex;
                }
            })

            // get the matched link from original list of categories
            let link = {...staticCpCategories[categoryIndex].links[linkIndex], relatedLinks: []};
            
            // shorthand to orig related links for this link
            const relatedLinks = staticCpCategories[categoryIndex].links[linkIndex].relatedLinks;
            // if the category does not have this link already
            if(!result[resultCategoryIndex].links.some((l) => l.name === link.name)){
                // add link to result in its appropriate category
                result[resultCategoryIndex].links.push(link);
            }
            
            // if the current item is a related link then find and add to related links if it doesn't already exist, at end of matching related links, add remaining related links
            if(relatedLinkIndex >= 0){
                let resultLinkIndex = -1;
                // find the new index of the link that is attached to the current related link
                result[resultCategoryIndex].links.forEach((l, lIndex) => {
                    if(l.name === link.name){
                        resultLinkIndex = lIndex;
                    }
                });

                // shorthand
                const resultLinkAddress = result[resultCategoryIndex].links[resultLinkIndex].relatedLinks;
                // if the related link doesn't already exist in the links related link arr then add it
                if(!resultLinkAddress.some((r) => r.name === relatedLinks[relatedLinkIndex].name)){
                    resultLinkAddress.push(relatedLinks[relatedLinkIndex]);
                }

                // if refined filter is not active
                if(!filterRelatedLinks){
                    // from here on is timing conditionals
                    // functionality: if the current link is (not the last in the arr and the next link does not share the same link index, ie the next item is not in the current links related
                    // (continued) link arr) or is the last link in the arr, then find the differences between the result obj and the orig object's related links, and add those to results
                    if(i !== indexList.length-1){
                        if(indexList[i+1].linkIndex !== linkIndex){
                            const resultRLSet = new Set(resultLinkAddress.map(rl => rl.name));
                            const relatedLinkDifference = relatedLinks.filter((rl) => !resultRLSet.has(rl.name) );
                            relatedLinkDifference.forEach(rld => resultLinkAddress.push(rld));
                        }
                    }else {
                        const resultRLSet = new Set(resultLinkAddress.map(rl => rl.name));
                        const relatedLinkDifference = relatedLinks.filter((rl) => !resultRLSet.has(rl.name) );
                        relatedLinkDifference.forEach(rld => resultLinkAddress.push(rld));
                    }
                }
            }

        });
        

        return result;
    };

    // searches through dynampic data set via brute force, would have to reindex for every notification otherwise
    const dynamicSearch = (needle) => {
        let results = [];
        const lowerNeedle = needle.toLowerCase();

        dynamicCpCategories.forEach(category => {
            const filteredLinks = category.links.filter((link) => {
                if(link.hasOwnProperty("relatedLink")){
                    return (
                        link.name.toLowerCase().includes(lowerNeedle) ||
                        link.description.toLowerCase().includes(lowerNeedle) ||
                        link.relatedLink.some((rel) => rel.name.toLowerCase().includes(lowerNeedle))
                    )
                }
                else {
                    return (
                        link.name.toLowerCase().includes(lowerNeedle) ||
                        link.description.toLowerCase().includes(lowerNeedle)
                    )
                }
            })

            if(filteredLinks.length > 0){
                results.push({...category, links: filteredLinks});
            }
        })

        return results;
    };

    // the actual meat of the debounce structure, runs rebuildIndexSearch and dynamic search and makes an aggregate array of the two
    const debounceSearch = (searchValue) => {
        const dynamicResults = dynamicSearch(searchValue);
        const indexResults = indexSearch(searchValue);
        
        let rebuiltResults = [];
        if(indexResults.length > 0) {
            rebuiltResults = rebuildIndexSearch(indexResults, refinedFilter);
        }

        const aggregateSearchResults = [...rebuiltResults, ...dynamicResults];        

        setCategorySearchResults(aggregateSearchResults);
        if(aggregateSearchResults.length > 0) {
            setControlPanelCategory(aggregateSearchResults[0]);
        }
        else{
            setControlPanelCategory(false);
        }

        setSearching(false);
    };

    // buffered resizing to lighten document repaint load
    // const debouncedSearchHandler = (fn) => {
    //     let timer;        
        
    //     return (...args) => {
    //         clearTimeout(timer);
    //         timer = setTimeout(() => {                
    //             fn(...args);

    //             // clearTimeout(timer);
    //         }, 750);
    //     }
    // };
    
    // ===================== USEEFFECT =====================
    useEffect(() => {
        // set up categories for searching in control panel

        const result = partialIndex(staticCpCategories);

        if(result){
            setIndexedStaticCategories(result);
        }

        const combinedCategories = [...staticCpCategories, ...dynamicCpCategories];

        setCategorySearchResults(combinedCategories);

        setControlPanelCategory(combinedCategories[0]);

        setSearchValid(true);
    }, []);

    // supposed to update page browser tab
    useEffect(() => {
        document.title = tabSelected.name;
    }, [tabSelected]);

    // handles the search of new input value with the debouncer
    useEffect(() => {
        if(searchValid) {
            setSearching(true);
            if(debounceContainer.current) {
                clearInterval(debounceContainer.current);
            }
            
            debounceContainer.current = setTimeout(() => {                
                debounceSearch(searchValue);
                debounceContainer.current = null;
            }, 500);


            // setSearching(true);
            // if(!debounceContainer.current || refinedFilter || !refinedFilter){
            //     debounceContainer.current = debouncedSearchHandler(debounceSearch);
            //     debounceContainer.current(searchValue);

            //     // debounceContainer.current = debouncedSearchHandler(test);

            // }else{
            //     debounceContainer.current(searchValue);
            // }
        }
    }, [searchValue, refinedFilter]);
    
    

    return <>
                <nav className='headerSearchContainer flex flexAlignCenter'>
                    {controlPanel && 
                        <section id='cp' className='flex flexColumn'>
                            <div className='flex flexColumn cp'>
                                <div className="headerStaticPages flex flexJustifyCenter flexAlignCenter">
                                    <div className="headerStaticPagesWrapper flex flexAlignCenter">
                                        {
                                            staticPages && staticPages.map((link, i) => (
                                                <Link to={link.to}  className="headerCategory headerStaticLinks flex flexJustifySpaceBetween flexAlignCenter" onClick={() => setControlPanel(false)}>
                                                    {link.name}
                                                    <RedirectIcon redirectClass="headerRedirectIcon" />
                                                </Link>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className='headerSearchMobileContainer flex flexCenter'>
                                    <input id="headerSearchMobile" autoComplete='off' spellCheck="false" placeholder='Explore...' maxLength={30} type="text" name="headerSearch" className='headerSearchMobile' value={searchValue} onChange={searchOnChangeHandler} onFocus={() => setControlPanel(true)} />
                                    {searchValue ? 
                                            <i id="headerSearchMobileCancel" className="fa fa-close flex flexCenter searchMobileCancel" onClick={clearSearchBarHandler}></i>
                                        :
                                            <i id="headerSearchMobileMag" className="fa fa-search flex flexCenter searchMobileMagGlass" onClick={focusOnSearch}></i>
                                    }
                                </div>
                                <div className='flex tcp'>
                                
                                    <div className="headerCategoriesContainer ">
                                        <div className="cpCategoriesListWrapper flex flexColumn flexStart">
                                            {
                                                categorySearchResults && categorySearchResults.map((category, i) => (
                                                    <div className={"headerCategory " + ((controlPanelCategory.name === category.name) ? "categorySelected" : "" )} onClick={() => setControlPanelCategory(categorySearchResults[i])} tabIndex={0}>{category.name}</div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className='controlPanelLinkContainer flex flexColumn' id='controlPanelLinkContainer'>
                                        {
                                            controlPanelCategory && controlPanelCategory.links.map((panel) => (
                                                <div className="panelWrapper">
                                                    <Link to={panel.link} onClick={() => setControlPanel(false)} className={"panel flex flexStart " + ((panel.relatedLinks && panel.relatedLinks.length > 0) ? "panelAlt" : "")} tabIndex={0}>
                                                        {
                                                            controlPanelCategory.hasIcons && <img src={panel.icon} alt='' className="panelImg"></img>
                                                        }
                                                        <div className="panelInformation flex flexColumn flexStart">
                                                            <p className='panelName'>
                                                                {panel.name}
                                                            </p>
                                                            <p className="panelDesc">
                                                                {panel.description}
                                                                <br />
                                                                {
                                                                    controlPanelCategory.clickToLearn && <b>Click here to learn more.</b>
                                                                }
                                                            </p>
                                                        </div>
                                                    </Link>
                                                    {panel.relatedLinks && panel.relatedLinks.length > 0 &&
                                                        <div className="relatedLinksContainer">    
                                                            <div className='relatedLinksWrapper flex'>
                                                                { panel.relatedLinks.map((relatedLink) => (
                                                                    <div className="relatedLinkWrapper">
                                                                        <Link to={relatedLink.link} onClick={() => setControlPanel(false)}>
                                                                            <div className="relatedLink textAlignCenter">
                                                                                {relatedLink.name}
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    }

                                                </div>
                                            ))
                                        }
                                        {
                                            (!controlPanelCategory && !searching) && <PixelEdumanLoader isAbsolute={true} message={"No results."} />
                                        }
                                        {
                                            searching && <PixelEdumanLoader isAbsolute={true} message={"Loading..."} excludeEduman={true} />
                                        }
                                    </div>
                                </div>
                                    {/* <div className='controlPanelGuideContainer flex flexColumn flexCenter' id='controlPanelGuideContainer'>
                                        <Link to="./download" className='flex flexColumn flexCenter'>
                                            <h3>DOWNLOAD OUR APP</h3>
                                            <p>Downloads the website as an app for your device!</p>
                                        </Link>
                                        <Link to="./guide" className='flex flexColumn flexCenter'>
                                            <h3>NEED HELP WITH THESE TOOLS?</h3>
                                            <p>Click here to view our control panel guide!</p>
                                        </Link>
                                    </div> */}
                            </div>
                        </section>
                    }
                        
                    <i id="headerSearchMobileMag" className="fa fa-search flex flexCenter searchMagGlassMobile" onClick={() => {
                        if(controlPanel) {
                            focusOnSearch();
                        }
                        setControlPanel(true);
                    } }></i>
                    <input id="headerSearch" autoComplete='off' spellCheck="false" placeholder='Explore...' maxLength={30} type="text" name="headerSearch" className='headerSearch' value={searchValue} onChange={searchOnChangeHandler} onFocus={() => setControlPanel(true)} />
                    {searchValue ? 
                            <i id="headerSearchCancel" className="fa fa-close flex flexCenter searchCancel" onClick={clearSearchBarHandler}></i>
                        :
                            <i id="headerSearchMag" className="fa fa-search flex flexCenter searchMagGlass" onClick={focusOnSearch}></i>
                    }
                </nav>
            </>
};

export default Search;